import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Copy from 'Src/components/Copy';
import { Flex } from 'Src/components/layout/Flex';
import { getTypedFormComponents } from 'Src/feature/form/getTypedFormComponents';
import { useForm } from 'Src/feature/form/useForm';
import { Modal } from 'Src/feature/modal/Modal';
import { ModalAction } from 'Src/feature/modal/ModalAction';
import { ModalActions } from 'Src/feature/modal/ModalActions';
import { ModalContent } from 'Src/feature/modal/ModalContent';
import { ModalHeader } from 'Src/feature/modal/ModalHeader';
import { ModalTitle } from 'Src/feature/modal/ModalTitle';

import { Check } from './models';

const sectionId = 'VoidCheckModal';

interface CheckVoidModalProps {
  open: boolean;
  check?: Check;
  form: ReturnType<typeof useForm<{ reasonId: number }>>,
  reasonOptions: { value: number, label: string }[],
  onClose: () => void;
  onVoid: () => void;
}

const { Form, Field } = getTypedFormComponents<{ reasonId: number }>();

const CheckVoidModal: FC<CheckVoidModalProps> = ({ open, check, form, reasonOptions, onClose, onVoid }) => {
  const { t } = useTranslation();

  return (
    <Modal data-testid={sectionId} open={open}>
      <ModalHeader>
        <ModalTitle copy={t('check.labels.voidCheck')} />
      </ModalHeader>

      <ModalContent>
        <Flex gap="sm" fullHeight fullWidth justifyContent="center">
          <Copy value={t('check.labels.voidCheckPrompt', { checkNumber: check?.number, checkItemsCount: check?.items.length, checkTotal: check?.balance.total.toFixed(2) })} align="center" />
          <Copy value={t('labels.noUndo')} align="center" variant="body" weight="bold" />
          <Form usedForm={form}>
            <Field
              type="dropdownList"
              name="reasonId"
              label={t('voidReason.label')}
              options={reasonOptions}
              fullWidth
            />
          </Form>
        </Flex>
      </ModalContent>

      <ModalActions>
        <ModalAction
          label={t('labels.cancel')}
          color="secondary"
          onClick={onClose}
        />
        <ModalAction
          label={t('check.labels.voidCheck')}
          color="primary"
          onClick={onVoid}
          disabled={!form.state.isValid}
        />
      </ModalActions>
    </Modal>
  );
};

export { CheckVoidModal };
